import { React, useState, useEffect } from "react";

const PopUpRace20Results = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;

    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };

    let spadesCards = [];
    let heartsCards = [];
    let clubsCards = [];
    let diamondsCards = [];
    let race20Markets = [];
    let race20Winner = "";

    if (marketType == 31) {
        spadesCards = resultData?.spades_cards
            ? resultData.spades_cards.split(",")
            : [];

        heartsCards = resultData?.hearts_cards
            ? resultData.hearts_cards.split(",")
            : [];

        clubsCards = resultData?.clubs_cards
            ? resultData.clubs_cards.split(",")
            : [];

        diamondsCards = resultData?.diamonds_cards
            ? resultData.diamonds_cards.split(",")
            : [];

        race20Markets = [
            "King of Spades",
            "King of Hearts",
            "King of Clubs",
            "King of Diamonds",
        ];

        race20Winner = resultData?.resultTxt || "";
    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="race20" style={{ display: marketType == 31 ? "" : "none" }}>
                        <div className="left-content">
                            <div className="card">
                                <div className="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div className="card-body">
                                    <div className="player-item">
                                        <b><span className="name" style={{ color: "#000" }}>King of Spades</span></b>
                                        <div className="player-card">
                                            <div className="BFBCardHandViewDealerab">
                                                <div className="BFBCardFanViewab" style={{ justifyContent: "flex-start", padding: "2px" }}>
                                                    {spadesCards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img
                                                                src={`/assets/images/cards/${card}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "45px",
                                                                    height: "auto"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="player-item">
                                        <b><span className="name" style={{ color: "#000" }}>King of Hearts</span></b>
                                        <div className="player-card">
                                            <div className="BFBCardHandViewDealerab">
                                                <div className="BFBCardFanViewab" style={{ justifyContent: "flex-start", padding: "2px" }}>
                                                    {heartsCards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img
                                                                src={`/assets/images/cards/${card}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "45px",
                                                                    height: "auto"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="player-item">
                                        <b><span className="name" style={{ color: "#000" }}>King of Clubs</span></b>
                                        <div className="player-card">
                                            <div className="BFBCardHandViewDealerab">
                                                <div className="BFBCardFanViewab" style={{ justifyContent: "flex-start", padding: "2px" }}>
                                                    {clubsCards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img
                                                                src={`/assets/images/cards/${card}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "45px",
                                                                    height: "auto"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="player-item">
                                        <b><span className="name" style={{ color: "#000" }}>King of Diamonds</span></b>
                                        <div className="player-card">
                                            <div className="BFBCardHandViewDealerab">
                                                <div className="BFBCardFanViewab" style={{ justifyContent: "flex-start", padding: "2px" }}>
                                                    {diamondsCards.map((card, index) => (
                                                        <div className="RSMImageView2ab" key={index}>
                                                            <img
                                                                src={`/assets/images/cards/${card}.svg`}
                                                                style={{
                                                                    width: "100%",
                                                                    maxWidth: "45px",
                                                                    height: "auto"
                                                                }}
                                                            />
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ marginTop: "10px" }}>
                                        {race20Markets.map((market, index) => {
                                            const winner = market === race20Winner;
                                            return (
                                                <div key={index} style={{ textAlign: "center", marginBottom: "18px" }}>
                                                    <div style={{ fontSize: "22px", fontWeight: "700" }}>
                                                        {market}
                                                    </div>
                                                    <div
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: "600",
                                                            marginTop: "4px",
                                                            color: "#000",
                                                            textTransform: "uppercase"
                                                        }}
                                                    >
                                                        {winner ? "WINNER" : "LOSER"}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default PopUpRace20Results;

